var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M8.798,4.163v-1.39c0-0.7-0.56-1.26-1.26-1.26h-1.61c-0.7,0-1.26,0.56-1.26,1.26v6.58c0,0.06,0,0.12,0.01,0.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M15.462,10.419c0.02,0.05,0.02,0.11,0.02,0.16v6.67c0,0.69-0.56,1.26-1.26,1.26h-1.61c-0.7,0-1.26-0.57-1.26-1.26v-1.96"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 3.544,
    y1: 1.513,
    x2: 9.906,
    y2: 1.513
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.236,
    y1: 18.487,
    x2: 16.598,
    y2: 18.487
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 10,
    cy: 10,
    r: 5.332
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 10,
    cy: 10,
    r: 1.352
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPump);
export default __webpack_public_path__ + "static/media/dark-pump.21519b5e9e291f9d7186e7b7196d7b85.svg";
export { ForwardRef as ReactComponent };